import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedUser } from '@edx/frontend-platform/auth';

const useUserLoginRedirect = () => {
  const user = getAuthenticatedUser();

  if (!user) {
    const loginUrl = new URL(`${getConfig().LMS_BASE_URL}/login`);
    loginUrl.searchParams.append('next', window.location.href);
    window.location.replace(loginUrl.href);
  }

  return null;
};

export default useUserLoginRedirect;
